import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import type { ReduxState, ThunkDispatchType } from 'app/redux/types';

import {
  selectedStream,
  selectLiveStreamPreferences,
  streamsByLiveMatchesSelector,
} from 'app/modules/LiveStream/selectors';
import { useLocationPath } from 'app/modules/Navigation/utils';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import type { SelectStream, SetDefaultStream } from './actions';
import { selectStream, setDefaultStream } from './actions';
import Player from './components/Players';

type LiveStreamProps = {
  closed: boolean;
  isEmptySelectedStream: boolean;
  isLoggedIn: boolean;
};

type DispatchProp = {
  dispatch: ThunkDispatchType<SelectStream | SetDefaultStream>;
};

const LiveStream = ({
  closed,
  isEmptySelectedStream,
  isLoggedIn,
  dispatch,
}: LiveStreamProps & DispatchProp) => {
  const { matchId: matchCenterMatchId } = useLocationPath();
  const [matchId, setMatchId] = useState(matchCenterMatchId);

  useEffect(() => {
    if (!closed) {
      return;
    }

    if (!matchCenterMatchId && matchCenterMatchId !== 0) {
      if (matchId) {
        dispatch(setDefaultStream());
        setMatchId(matchCenterMatchId);
      }

      return;
    }

    if (
      (isEmptySelectedStream && matchCenterMatchId)
       || (matchCenterMatchId !== matchId)
    ) {
      dispatch(selectStream(matchCenterMatchId));
      setMatchId(matchCenterMatchId);
    }
  }, [matchCenterMatchId]);

  if (closed || !isLoggedIn) {
    return null;
  }

  return (
    <Player />
  );
};

const mapStateToProps = (state: ReduxState) => ({
  closed: selectLiveStreamPreferences(state).closed,
  isEmptySelectedStream: !selectedStream(state) && (streamsByLiveMatchesSelector(state).size > 0),
  isLoggedIn: selectIsLoggedIn(state),
});

export default connect(mapStateToProps)(LiveStream);
